// src/index.ts
import { extendBaseTheme } from "@stepstone-genesis/dresscode-base";
import { caterer as baseCatererTheme } from "@stepstone-genesis/design-tokens";
var caterer = extendBaseTheme("caterer", baseCatererTheme);
export {
  caterer
};
